import React from "react";
import ModalDialog, { DialogContent } from '../../AlmeDialog/ModalDialog';
import styled from "styled-components";
import Button from "syf-component-library/ui/atoms/Button";
import { focusMessageBox } from "../../AlmeUtilities/dom-utils";
const CloseSurveyLink = styled(Button) `
        float:right;
        color: ${({ theme }) => theme.button.text};
        padding: 10px !important;
        text-transform: none !important;
`;
const SurveyDialogContent = styled(DialogContent) `
    padding: 0;
    margin: 0;
    overflow-x: hidden;
`;
const SurveyIframe = styled.iframe `
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    flex-grow: 1;
`;
const IframeContainer = styled.div `
display: flex;
flex-direction: row;
align-items: stretch;
flex-grow: 1;
overflow: hidden;
`;
const CloseIconSpan = styled.span `
float:right;
padding: 5px !important;
text-transform: none !important;
margin-left: 0px !important;
color: ${({ theme }) => theme.button.text};
&:after { 
    content: "\\2716";           
}
`;
const CloseSurveyContainer = styled.div `
display: flex;
flex-direction: row;
align-self: end;
`;
const AlmeOverlaySurveyDialog = (props) => {
    const handleSurveyClose = () => {
        props.onCloseSurvey(true);
        focusMessageBox();
    };
    return (React.createElement(React.Fragment, null, props.isOpen
        ? React.createElement(ModalDialog, { id: 'survey-overlay-dialog', ariaLabel: 'Live chat survey dialog', style: { width: "100%", height: "inherit" } },
            React.createElement(SurveyDialogContent, null,
                React.createElement(CloseSurveyContainer, null,
                    React.createElement(CloseSurveyLink, { buttonType: "text", id: "close-survey-button", "data-testid": "close-survey-overlay-dialog-link", onClick: handleSurveyClose },
                        "Close Survey",
                        React.createElement(CloseIconSpan, { "aria-hidden": true }))),
                React.createElement(IframeContainer, null,
                    React.createElement(SurveyIframe, { title: "SurveyOverlay", src: props.surveyURL, role: "region", "aria-label": "Chat Transcript" }))))
        : null));
};
export default AlmeOverlaySurveyDialog;
